import { render, staticRenderFns } from "./PPC.vue?vue&type=template&id=1a8fef88&"
var script = {}


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIFooter: require('/opt/build/repo/components/UI/Footer.vue').default})
